import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatComponent } from './chat.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageRowItemComponent } from './message-row-item/message-row-item.component';
import { PipesModule } from 'src/app/_pipes/pipes.module';



@NgModule({
  declarations: [
    ChatComponent,
    MessageRowItemComponent  
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
  ],
  exports: [
    ChatComponent,
    MessageRowItemComponent
  ]
})
export class ChatModule { }
